import type { PixelCanvas } from '../pixel.js';
import { box, drawBox, drawCylinder, faces } from './iso.js';
import type { FurniDrawer } from './iso.js';

/**
 * Staff NPC "hire posts": a small signpost placed where the live NPC spawns
 * (see `@kopi-kaki/protocol` `spawnsStaff`). The post itself is just a
 * marker -- the character doing the walking around is the avatar renderer.
 */
function signPostDrawer(flagColor: string, trim: string): FurniDrawer {
  return (pc: PixelCanvas) => {
    drawCylinder(pc, 0.05, 0, 46, '#8a6a46', '#6b4e30');
    drawBox(pc, box(-0.02, 0.3, -0.18, 0.18, 30, 48, faces(flagColor)));
    drawBox(pc, box(-0.02, 0.3, -0.18, 0.18, 46, 50, faces(trim)));
  };
}

export const STAFF_DRAWERS: Record<string, FurniDrawer> = {
  bodyguard_post: signPostDrawer('#2b2d33', '#c9a227'),
  bar_manager_post: signPostDrawer('#7a3b2e', '#e8c77a'),
  lifeguard_post: signPostDrawer('#d64545', '#ffffff'),
  stadium_coach_post: signPostDrawer('#2f6b3a', '#ffd23f'),
};
